import * as React from 'react';
import AppModal from 'views/Modals/AppModal';
import { getLocalization } from 'global/global';
import { Form } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from 'index';
import { saveComment, savePOI } from 'actions/pois';
import { DroppedDataPoint } from '..';

interface Props {
  selectedForm: string;
  droppedDataPoint: DroppedDataPoint;
  reset: (move: boolean) => void;
}

export default function UpdateStatus(props: Props) {

  const dispatch = useAppDispatch();
  const clientPersist = useAppSelector(state => state.clientPersist);

  const { droppedDataPoint, selectedForm } = props;
  const [comment, setComment] = React.useState('');

  const [loading, setLoading] = React.useState(false);

  const onUpdate = () => {
    if (loading) {
      return;
    }
    setLoading(true);
    const dp = {
      id: droppedDataPoint.id,
      kanbanStatus: droppedDataPoint.status,
      questionnaire_id: selectedForm
    };
    const saved = dispatch(savePOI(dp, { copyComponents: 1 }));
    saved.then(res => res.json()).then(json => {
      if (json.rowId) {
        if (comment) {
          void dispatch(saveComment(dp.id, clientPersist.userName || '', {
            comment,
            date: Date.now(), username: clientPersist.userName || ''
          }));
        }
        props.reset(true);
      }
      setLoading(false);
    }).catch(e => {
      console.log(e);
      setLoading(false);
    });
  };

  const close = () => {
    if (loading) {
      return;
    }
    props.reset(false);
  };

  const body = (
    <>
      <Form.Group>
        <Form.Label>{getLocalization('addComment')}</Form.Label>
        <Form.Control
          type="text"
          value={comment}
          size="sm"
          onChange={(e) => {
            setComment(e.target.value);
          }}
        />
      </Form.Group>
    </>
  );

  return (
    <AppModal
      title={getLocalization('update')}
      body={body}
      onConfirm={onUpdate}
      confirmText={getLocalization('update')}
      onCancel={close}
      cancelText={getLocalization('cancel')}
    />
  );
}
